import React from "react";
import { Outlet } from "react-router-dom";
import AuthGuard from "./AuthGuard";
import Header from "../components/header";
import FooterV2 from "../components/FooterV2";

function Private({ role }) {
  return (
    <>
      <AuthGuard role={role}>
        <Header />
        <Outlet />
        <FooterV2 />
      </AuthGuard>
    </>
  );
}

export default Private;
